import { render, staticRenderFns } from "./tenant-page.vue?vue&type=template&id=d09dceda&scoped=true&"
import script from "./tenant-page.vue?vue&type=script&lang=js&"
export * from "./tenant-page.vue?vue&type=script&lang=js&"
import style0 from "./tenant-page.vue?vue&type=style&index=0&id=d09dceda&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d09dceda",
  null
  
)

export default component.exports